import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from 'styled-components';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from '../assets/Images/LOGO.jpeg';
import { BASE_URL } from '../Config';

const RegistrationDiv = styled.div`
  background-color: #e6f7f9;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

  .container {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    width: 70%;
    height: 76%;
    overflow: hidden;
    @media (max-width: 768px) {
      flex-direction: column;
      height: auto;
    }
  }

  .imageContainer {
    flex: 1;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    height: 100%;
    img {
      width: 80%;
      height: 80%;
      object-fit: cover;
      position: absolute;
      top: 50px;
      left: 50px;
      opacity: 0;
      transition: opacity 1s ease-in-out;
    }
    img.active {
      opacity: 1;
    }
    @media (max-width: 768px) {
      height: 200px;
    }
  }

  .formContainer {
    flex: 0.5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 40px;
    background-color: white;
    @media (max-width: 768px) {
      padding: 20px;
    }
  }

  .logo {
    display: block;
    margin: -19px auto -51px;
    width: 200px;
  }

  .form {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .input {
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
    width: 92%;
  }

  .button {
    padding: 10px;
    border-radius: 5px;
    border: none;
    background-color: #007bff;
    color: white;
    cursor: pointer;
    width: 100%;
  }

  .link {
    background-color: transparent;
    border: none;
    color: #007bff;
    cursor: pointer;
    text-decoration: underline;
    margin-top: 10px;
    text-align: right;
    font-size: 12px;
  }

  .error {
    color: red;
    margin-top: -10px;
    font-size: 12px;
    margin-bottom: 3px;
  }

  .signUpContainer {
    margin-top: -7px;
    text-align: center;
  }

  .signUpLink {
    color: #007bff;
    cursor: pointer;
    text-decoration: underline;
  }

  .signInUsing {
    text-align: center;
    margin: 53px 0 10px;
    font-size: 12px;
    color: #333;
  }

  .socialButtonsContainer {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-bottom: 20px;
  }

  .h3Tag {
    align-self: center;
  }
`;

const UserRegistration = () => {
  const [errors, setErrors] = useState({});
  const [imageUrls, setImageUrls] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    mobileNo: "",
    email: "",
    AltMobileNo: "",
  });

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/image`);
        const data = await response.json();
        if (response.ok) {
          const updatedImageUrls = data.map(url => url.imageUrl);
          setImageUrls(updatedImageUrls);
        } else {
          console.error('Failed to fetch images');
        }
      } catch (error) {
        console.error('Error fetching image:', error);
      }
    };

    fetchImages();

    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imageUrls.length);
    }, 5000);

    return () => clearInterval(intervalId);
  }, [imageUrls.length]);

  const validate = () => {
    const errors = {};
    if (!formData.name) errors.name = "Name is required";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) errors.email = "Valid Email ID is required";
    if (!/^\d{10}$/.test(formData.mobileNo)) errors.mobileNo = "Valid 10-digit Mobile No is required";
    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'mobileNo') {
      if (value.length <= 10) {
        setFormData({ ...formData, [name]: value });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setSubmitting(true);
    try {
      const response = await fetch(`${BASE_URL}/api/user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        toast.success(`Registration successful! Your password has been sent to your email: ${formData.email} and Whatsapp`);
        setTimeout(() => {
          navigate('/login');
        }, 4000);
      } else {
        const data = await response.json();
        toast.error(`Registration Error! ${data.error}`);
      }
    } catch (error) {
      setErrors({ apiError: "Failed to register. Please try again." });
    } finally {
      setSubmitting(false); // Set submitting state to false to enable the button again
    }
  };

  return (
    <RegistrationDiv>
      <div className="container">
        <div className="imageContainer">
          {imageUrls.length > 0 ? (
            imageUrls.map((url, index) => (
              <img
                key={index}
                src={`${BASE_URL}${url}`}
                alt={`Slideshow ${index}`}
                className={index === currentImageIndex ? "active" : ""}
              />
            ))
          ) : (
            <p>No images available</p>
          )}
        </div>
        <div className="formContainer">
          <img src={logo} alt="Logo" className="logo" />
          <h3 className="h3Tag">Registration Form</h3>
          <form className="form" onSubmit={handleSubmit}>
            <div className="flexRow">
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                className="input"
              />
              {errors.name && <p className="error">{errors.name}</p>}
            </div>
            <div className="flexRow">
              <input
                type="email"
                name="email"
                placeholder="Email ID"
                value={formData.email}
                onChange={handleChange}
                className="input"
              />
              {errors.email && <p className="error">{errors.email}</p>}
            </div>
            <div className="flexRow">
              <input
                type="number"
                name="mobileNo"
                placeholder="Mobile No"
                value={formData.mobileNo}
                onChange={handleChange}
                className="input"
              />
              {errors.mobileNo && <p className="error">{errors.mobileNo}</p>}
            </div>

            <div className="flexRow">
              <input
                type="number"
                name="AltMobileNo"
                placeholder="Alt Mobile No"
                value={formData.AltMobileNo}
                onChange={handleChange}
                className="input"
              />
              {errors.AltMobileNo && <p className="error">{errors.AltMobileNo}</p>}
            </div>
            {errors.apiError && <p className="error">{errors.apiError}</p>}
            <button className="button" type="submit" disabled={submitting} >Submit</button>
            <button className="link" type="button" onClick={() => navigate('/login')}>Back to Login</button>
          </form>
        </div>
      </div>
    </RegistrationDiv>
  );
};

export default UserRegistration;
